module.exports = __webpack_public_path__ + "img/outcome_1.5e3209a0.png";